import { useStateValue } from '../../context/StateValueContext';
import { PERMISSIONS } from '../../constants/permissions';
import { hasPermission } from '../../functions/permissionUtils';
import AlertsEnrolment from './AlertsEnrolment';

const ALL_COMPANIES_PERMISSIONS = [PERMISSIONS.ENROLMENT_READ_ALL, PERMISSIONS.ENROLMENT_WRITE_ALL];

export default function EnrolmentSwitcher() {
  const [{ user }] = useStateValue();

  if (ALL_COMPANIES_PERMISSIONS.some((p) => hasPermission(user, p))) {
    return <AlertsEnrolment />;
  }

  return <AlertsEnrolment variant="client" />;
}
